import { AddAccountForm } from '../AddAccountForm'

export function StepConnect({ onAccountCreated }) {
  return (
    <div className="onboarding-step">
      <h2>Step 1 — Connect your mailbox</h2>
      <p className="step-hint">
        Add your IMAP credentials. We use read-only access — emails on your server are never modified.
      </p>
      <AddAccountForm onSuccess={(account) => onAccountCreated(account)} />
    </div>
  )
}
